import { RcClasses } from '../../../../foundation';
export var RcTabsClasses = RcClasses(['indicator'], 'RcTabs');
